import { render, staticRenderFns } from "./Apps.vue?vue&type=template&id=4e845953&scoped=true"
import script from "./Apps.vue?vue&type=script&lang=js"
export * from "./Apps.vue?vue&type=script&lang=js"
import style0 from "./Apps.vue?vue&type=style&index=0&id=4e845953&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e845953",
  null
  
)

export default component.exports